import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlock"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V19.5H22V21H2V19.5H4V3ZM8 7H11V8.5H8V7ZM13 7H16V8.5H13V7ZM8 11H11V12.5H8V11ZM13 11H16V12.5H13V11ZM8 15H11V16.5H8V15ZM13 15H16V16.5H13V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlock;
